import React from 'react'
import { Image } from '../image/image'

export class ArticleImageContainer extends React.Component {
  render() {
    return (
      <figure className="post-cover__media-wrap post-cover__media-wrap--image">
        <meta itemProp="caption" content={this.props.title} />
        <meta itemProp="thumbnail" content={this.props.url} />
        <meta itemProp="associatedArticle" content={this.props.post_url} />
        <meta itemProp="contentUrl" content={this.props.post_url} />
        <meta itemProp="description" content={this.props.caption} />
        <Image
          lazyLoad={this.props.lazy_load}
          src={this.props.url}
          srcSet={this.props.srcset}
          className="post-cover__media post-cover__media--image"
          title={this.props.credit}
          alt={this.props.alt}
        />
      </figure>
    )
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/article_image/articleImage.container.js